import React, { memo } from 'react';

import classNames from 'classnames';

import { Popup } from '@shared/ui';

import { AlbumsInterface } from './AlbumsInterface';
import cls from './ConstructionProgressBlock.module.css';
import { ConstructionProgressDnD } from './ConstructionProgressDnD/ConstructionProgressDnD';
import { useConstructionProgressBlock } from './useConstructionProgressBlock';
import { ProgressContext } from '../../Context/ProgressContext';
import { ModalConstructionProgress } from '../../Modals/ModalConstructionProgress/ModalConstructionProgress';

interface ConstructionProgressBlockProps {
    classes?: string;
}

export const ConstructionProgressBlock = memo(({ classes }: ConstructionProgressBlockProps) => {
    const {
        contextValue,
        handleInputChange,
        is_customer,
        progress_tariff_access_edit,
        onNotOwnerHandler,
        isShowPopup,
        onHidePopup,
        modalMode,
        t,
    } = useConstructionProgressBlock();

    return (
        <ProgressContext.Provider value={contextValue}>
            <Popup
                popupContentClassName={cls.popup}
                isOpen={isShowPopup}
                onHidePopup={onHidePopup}
                contentText=" "
            >
                <>
                    {t('ConstructionProgressBlock.return.popup.text.part1')}
                    <br />
                    {t('ConstructionProgressBlock.return.popup.text.part2')}
                </>
            </Popup>

            {modalMode === 'constructionProgress' && <ModalConstructionProgress />}
            <div className={classNames(cls.ConstructionProgressBlock, [classes])}>
                <div id="project_step_by_step_photos" className={classNames(cls.header)}>
                    <div className={cls.headerInterface}>
                        <span>{t('ConstructionProgressBlock.return.header.span')}</span>
                    </div>
                    <AlbumsInterface
                        progress_tariff_access_edit={progress_tariff_access_edit}
                        onNotOwnerHandler={onNotOwnerHandler}
                        handleInputChange={handleInputChange}
                        is_customer={is_customer}
                    />
                </div>
                <ConstructionProgressDnD />
            </div>
        </ProgressContext.Provider>
    );
});
